/* eslint-disable default-case */
import
{
    GET_APPSTATE
    , GET_APPSTATE_PENDING
    , GET_APPSTATE_FULFILLED
    , GET_APPSTATE_REJECTED
    , SET_APPSTATE
    , SET_APPSTATE_PENDING
    , SET_APPSTATE_FULFILLED
    , SET_APPSTATE_REJECTED
    , CHANGE_MAP_LAYER_ID
    , UPDATE_APP_STATE
}
    from '../actions/appStateActions';

const initialState = {
    isFetchingAppState: false,
    isSettingAppState: false
};

export function appState(state = initialState, action)
{
    switch (action.type)
    {
        case GET_APPSTATE:
        case GET_APPSTATE_PENDING:
        {
            return {
                ...state,
                appState: action.payload,
                isFetchingAppState: true
            };
        }
        case GET_APPSTATE_FULFILLED:
        {
            return {
                ...state,
                appState: action.payload,
                lastError: {},
                isFetchingAppState: false
            };
        }
        case GET_APPSTATE_REJECTED:
        {
            return {
                ...state,
                appState: undefined,
                lastError: action.payload,
                isFetchingAppState: false
            };
        }
        case SET_APPSTATE:
        case SET_APPSTATE_PENDING:
        {
            return {
                ...state,
                appState: action.payload,
                isSettingAppState: true
            };
        }
        case SET_APPSTATE_FULFILLED:
        {
            return {
                ...state,
                appState: action.payload,
                lastError: {},
                isSettingAppState: false
            };
        }
        case SET_APPSTATE_REJECTED:
        {
            return {
                ...state,
                appState: undefined,
                lastError: action.payload,
                isSettingAppState: false
            };
        }

        case CHANGE_MAP_LAYER_ID:
        {
            return {
                ...state,
                mapCurrentLayerId: action.payload,
                lastError: {}
            };
        }

        case UPDATE_APP_STATE:
        {
            return {
                ...state,
                appState: action.payload
            };
        }

    }

    return state;

}
